import { app } from '../../../../../../app';
import { Controller } from './assign-hard-token.controller';

app.component('companyUserDirectoriesManageUserDetailsAssignHardToken', {
    controller: Controller,
    templateUrl: require('./assign-hard-token.html'),
    bindings: {close: '&', dismiss: '&', resolve: '<'},
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/assign-hard-token/assign-hard-token.component.js